import { Map } from "immutable";

import { Course } from "seneca-common/features/course/state";
import makeCourseSelectors from "seneca-common/features/course/state/selectors/makeCourseSelectors";
import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { PATH_TO_COURSES_QUERY } from "../consts";
import CoursesQuery from "../models/CoursesQuery";
import * as aggregationSelectors from "./aggregations";

type State = any;
type TagId = string;
type CourseId = string;
type Count = number;
type Aggregations = Map<TagId, Count>;
type Courses = Map<CourseId, Course>;

export function getCoursesQuerySlice(state: State): CoursesQuery {
  return state.get(PATH_TO_COURSES_QUERY);
}

export function makeSelectors(getStateSlice: (arg0: any) => CoursesQuery) {
  const getAggregationsSelector = (state: CoursesQuery): Aggregations =>
    state.aggregations;

  const getCoursesSelector = (state: CoursesQuery): Courses => {
    return state.courses;
  };

  const getAggregations: (arg0: State) => Aggregations = composeSelector(
    getStateSlice,
    getAggregationsSelector
  );

  const getCourses: (arg0: State) => Courses = composeSelector(
    getStateSlice,
    getCoursesSelector
  );

  const getCountByTagId: (
    arg0: State,
    arg1: TagId
  ) => number | null | undefined = composeSelector(
    // @ts-ignore
    getAggregations,
    aggregationSelectors.getCountByTagId
  );

  const tagHasNoResults: (arg0: State, arg1: TagId) => boolean =
    // @ts-ignore
    composeSelector(getAggregations, aggregationSelectors.tagHasNoResults);

  const {
    getCourse,
    getCourseTagIds,
    getAllCourseIds,
    getAllCourseIdsWithoutPremium,
    getCourseName,
    getCourseNames,
    getCourseDescription,
    getCourseAuthors,
    getCourseReferences,
    getCourseHeaderImageURL,
    getCourseSectionIds,
    getCourseSubscriptionTier,
    courseIsPremium,
    courseExists,
    getCourseExamQuestionsCount,
    doesCourseHaveExamQuestions
  } = makeCourseSelectors(getCourses);

  return {
    getCourses,
    getAggregations,
    getCountByTagId,
    tagHasNoResults,
    getCourse,
    getCourseTagIds,
    getAllCourseIds,
    getAllCourseIdsWithoutPremium,
    getCourseName,
    getCourseNames,
    getCourseDescription,
    getCourseAuthors,
    getCourseReferences,
    getCourseHeaderImageURL,
    getCourseSectionIds,
    getCourseSubscriptionTier,
    courseIsPremium,
    courseExists,
    getCourseExamQuestionsCount,
    doesCourseHaveExamQuestions
  };
}

export const {
  getCourses,
  getCountByTagId,
  tagHasNoResults,
  getCourse,
  getAggregations,
  getCourseTagIds,
  getAllCourseIds,
  getAllCourseIdsWithoutPremium,
  getCourseName,
  getCourseNames,
  getCourseDescription,
  getCourseAuthors,
  getCourseReferences,
  getCourseHeaderImageURL,
  getCourseSectionIds,
  getCourseSubscriptionTier,
  courseIsPremium,
  courseExists,
  getCourseExamQuestionsCount,
  doesCourseHaveExamQuestions
} = makeSelectors(getCoursesQuerySlice);
